import { Button } from "@mui/material"
import { ErrorRounded, InfoRounded, WarningRounded } from "@mui/icons-material"
import "./styles.scss"

/**
 * Информационная панель
 * @param id: Идентификатор панели (для сохранения статуса в localStorage)
 * @param title? Заголовок панели
 * @param subtitle?  Подзаголовок панели
 * @param message Текст панели
 * @param open? Открыта
 * @param Тип панели / Инфо|Предупреждение|Ошибка
 */
function InfoPanel(props) {
  const title = props.title ? (
    <span className="panel-header">{props.title}</span>
  ) : null
  const subtitle = props.subtitle !== null ? props.subtitle : null
  let color = "inherit"
  let icon

  // Установка видимости панели по клику на кнопке
  const setPanelOpen = () => {
    // Небольшая задержка для waves-анимаций
    setTimeout(() => {
      props.setter?.(!props.open, props.id)
    }, 300)
  }

  // Тип панели (INFO | WARNING | ERROR)
  switch (props.type) {
    case "info":
      color = "info"
      icon = <InfoRounded />
      break
    case "warning":
      color = "warning"
      icon = <WarningRounded />
      break
    case "error":
      color = "error"
      icon = <ErrorRounded />
      break
    default:
      color = "inherit"
      icon = <></>
  }

  const iconDisplay = !props.open ? "inline" : "none"
  const panelDisplay = props.open ? "block" : "none"

  return (
    <>
      <h1 className={color}>
        <InfoRounded sx={{ display: iconDisplay }} onClick={setPanelOpen} />
        <div>
          {title}
          <span className="subtitle">{subtitle}</span>
        </div>
      </h1>
      <div
        className={`info-panel ${props.type}`}
        style={{ display: panelDisplay }}
      >
        <div className="panel-head">
          <div className="icon-wrapper">{icon}</div>
          <div className="action-wrapper">
            <Button variant="outlined" color={color} onClick={setPanelOpen}>
              Ознакомлен, больше не показывать
            </Button>
          </div>
        </div>
        {title}
        <div>{props.message}</div>
      </div>
    </>
  )
}

export default InfoPanel
